import "./UsageTable.scss";

import _ from "lodash";
import { useMemo } from "react";

import type { InfoByModel } from "../../../../hooks/reactQueryHooks/useBilling";
import type { PlaygroundModel } from "../../../../hooks/reactQueryHooks/usePlayground";
import { useMediaQuery } from "../../../../hooks/useMediaQuery";
import {
  formatCurrency,
  formatNumber,
} from "../../../../utils/NumbersFormatting";
import { UsageTableLg } from "./UsageTableLg";
import { UsageTableSm } from "./UsageTableSm";

interface UsageTableControllerProps {
  tableData: {
    [key: string]: {
      cached: InfoByModel;
      active: InfoByModel;
      costSavings: number;
      cogCachePrice: number;
    };
  };
  models: PlaygroundModel[] | undefined;
}

const UsageTableController: React.FC<UsageTableControllerProps> = ({
  tableData,
  models,
}) => {
  const isMd = useMediaQuery("md");

  const data = useMemo(() => {
    if (!models || !tableData) return;

    if (_.isEmpty(tableData)) {
      return [];
    }

    return Object.keys(tableData).map(key => {
      const { cached, active, costSavings, cogCachePrice } = tableData[key];
      return {
        modelName:
          models?.find(({ model }) => model === key)?.displayName || key,
        tokens: {
          paid: formatNumber(active.inputTokens + active.outputTokens),
          free: formatNumber(cached.inputTokens + cached.outputTokens),
        },
        costSavings: formatCurrency(costSavings),
        totalCost: formatCurrency(cogCachePrice),
      };
    });
  }, [tableData, models]);

  return data ? (
    <>
      <h4 className="billing-table-title">Breakdown by models:</h4>
      {isMd ? <UsageTableSm data={data} /> : <UsageTableLg data={data} />}
    </>
  ) : null;
};

export { UsageTableController };
